module.exports = __webpack_public_path__ + "static/media/main-stage-3.b8041c24.png";